export default "__VITE_ASSET__CuAgP_92__"